/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoPagoPa } from './tipo-pago-pa';


export interface PagoPaConfigForm { 
    tipoPagoPa?: TipoPagoPa;
    loginUrl?: string;
    basePath?: string;
    grantType?: string;
    tipoDovuto?: string;
    idA2A?: string;
    idDominio?: string;
    idTipoPendenza?: string;
    codiceContabilita?: string;
    cartBasePath?: string;
    companyName?: string;
    codiceIPA?: string;
    codiceServizio?: string;
    idInstallazione?: string;
    printerBasePath?: string;
    username?: string;
    password?: string;
    scadenza?: string;
    tassonomia?: string;
    ibanAccredito?: string;
    printerUsername?: string;
    printerPassword?: string;
}



